// src/components/MyCampaigns.jsx
import { useEffect, useState } from "react";
import { supabase } from "../utils/supabaseClient";
import {
  Box,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Spinner,
  Text,
  Flex,
  Badge,
} from "@chakra-ui/react";

/**
 * MyCampaigns
 * Displays all paid flyer slots for the current business.
 * - Filters flyer_slots by businessId (uuid) and status = 'paid'.
 * - Each row represents a booked slot in a quarterly print run.
 */
export default function MyCampaigns({ businessId, flyerId, groupId }) {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchSlots() {
      if (!businessId) return;

      setLoading(true);
      try {
        const { data, error } = await supabase
          .from("flyer_slots")
          .select("id, flyer_id, slot_number, postcode, status")
          .eq("business_id", businessId)
          .eq("status", "paid");

        if (error) throw error;
        setSlots(data || []);
      } catch (err) {
        console.error("Failed to fetch campaign slots:", err);
        setSlots([]);
      } finally {
        setLoading(false);
      }
    }

    fetchSlots();
  }, [businessId]);

  return (
    <Box p={6}>
      <Heading size="md" mb={4}>
        📦 My Campaign Slots (Quarterly Print Runs)
      </Heading>

      {loading ? (
        <Flex justify="center" align="center" minH="100px">
          <Spinner />
        </Flex>
      ) : slots.length === 0 ? (
        <Text fontSize="sm" color="gray.500">
          No campaign slots found. Book your first 🔥 Hot Deal slot to appear in
          the next quarterly print run.
        </Text>
      ) : (
        <Table variant="simple" size="sm">
          <Thead>
            <Tr>
              <Th>Flyer</Th>
              <Th>Slot</Th>
              <Th>Postcode</Th>
              <Th>Status</Th>
            </Tr>
          </Thead>
          <Tbody>
            {slots.map((s) => (
              <Tr key={s.id}>
                <Td>{s.flyer_id ? s.flyer_id.slice(0, 8) : "—"}</Td>
                <Td>{s.slot_number ?? "—"}</Td>
                <Td>{s.postcode || "—"}</Td>
                <Td>
                  <Badge
                    colorScheme={
                      s.status === "paid"
                        ? "green"
                        : s.status === "pending"
                        ? "yellow"
                        : "gray"
                    }
                  >
                    {s.status}
                  </Badge>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Box>
  );
}
